import React from "react";
import actions from "./Settings.actions";

const SettingsContext = React.createContext();

const settingsInitialState = {
  editProfileToggle: false,
  editProfileForm: {
    firstName: "",
    lastName: "",
    company: "",
    title: "",
    language: "",
    phone: {
      countryCode: "",
      phoneNumber: "",
    },
    image: null,
  },
};

const settingsReducer = (state, action) => {
  switch (action.type) {
    case actions.EDIT_PROFILE_TOGGLE:
      return {
        ...state,
        editProfileToggle: !state.editProfileToggle,
      };
    case actions.EDIT_PROFILE:
      return {
        ...state,
        editProfileForm: { ...state.editProfileForm, ...action.payload },
      };
    default:
      return state;
  }
};

export { SettingsContext, settingsInitialState, settingsReducer, actions };
